import $ from 'jquery';

$(document).ready(function () {
    $(".finna-search-icon").on('click', (event) => {
        event.preventDefault();
        $("#finna-search").submit();
    });
});